import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  accreditations: [],
  applicant: {},
  denial_reason: null,
  denial_reasons: [],
  engagement_source: null,
  engagement_sources: [],
  identity_document_type_1st: null,
  identity_document_type_2nd: null,
  interview_note: null,
  interviewer_id: null,
  interviewers: [],
  interview: { status: { id: 0 } },
  message: '',
  isRadioDisabled: false,
  isReasonDisabled: false,
  loading: true,
  visible: false,
  positions: [],
  skills: [],
};

function onLoadFormData(state) {
  return { ...state, loading: true };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { interviewers, passed_interview_positions, interview } = payload;

  const { denial_reason, identity_document_type_1st, identity_document_type_2nd, status } = interview;

  const result = {
    ...state,
    ...payload,
    ...interview,
    identity_document_type_1st: identity_document_type_1st ? identity_document_type_1st.id : null,
    identity_document_type_2nd: identity_document_type_2nd ? identity_document_type_2nd.id : null,
    positions: payload.positions,
    // 0 - pending, 1 - denied, 2 - approved
    denied: status.id === 1,
    isRadioDisabled: !!status.id,
    isReasonDisabled: denial_reason,
    interviewers: interviewers.map(item => ({ id: item.id, name: `${item.first_name} ${item.last_name}` })),
    loading: false,
  };

  if (payload.interview && payload.interview.positions) {
    result.skills = payload.interview.positions.map(item => ({
      position_name: item.name,
      level: item.level,
      skill: item.id,
      disabled: true,
    }));
  }

  if (!result.skills.length) {
    result.skills = passed_interview_positions.map(item => ({
      position_name: item.name,
      skill: item.id,
      level: '',
    }));
  }

  return result;
}

function onClearStore() {
  return { ...initState };
}

function onChangeProperty(state, { payload }) {
  const { prop, value } = payload;

  return { ...state, [prop]: value };
}

function onUpdateApplicant(state) {
  return { ...state, loading: true };
}

function onUpdateApplicantSuccess(state, { payload }) {
  return { ...state, ...payload };
}

function onUpdateApplicantFail(state, { payload }) {
  return { ...state, ...payload };
}

function onGetAccreditationsSeccess(state, { payload }) {
  const accreditations = [...state.accreditations];
  accreditations[payload.index] = payload.data;

  return { ...state, accreditations };
}

function onOpenInterviewPopup(state, { payload = {} }) {
  return { ...state, ...payload, visible: true, loading: true };
}

export default createReducer(initState, {
  [actions.APPROVE_APPLICANT]: onUpdateApplicant,
  [actions.APPROVE_APPLICANT_FAIL]: onUpdateApplicantFail,
  [actions.APPROVE_APPLICANT_SUCCESS]: onUpdateApplicantSuccess,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.DENY_APPLICANT]: onUpdateApplicant,
  [actions.DENY_APPLICANT_FAIL]: onUpdateApplicantFail,
  [actions.DENY_APPLICANT_SUCCESS]: onUpdateApplicantSuccess,
  [actions.GET_ACCREDITATIONS_SUCCESS]: onGetAccreditationsSeccess,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.OPEN_POPUP]: onOpenInterviewPopup,
  [actions.UPDATE_INTERVIEW_FAIL]: onUpdateApplicantFail,
  [actions.UPDATE_INTERVIEW_SUCCESS]: onUpdateApplicantSuccess,
});
